import styled, { css } from 'styled-components';
import Text from 'v3/components/Text';
import theme from 'v3/theme';

/* ── AttachmentNFCheckboxes ────────────────────────────────────────────── */

export const Wrapper = styled.div`
  margin-top: 0.5rem;
`;

export const ToggleList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin-top: 0.375rem;
`;

export const NfToggleButton = styled.button`
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.5;
  user-select: none;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;

  ${({ active }) =>
    active
      ? css`
          border: 1.5px solid #1976d2;
          background: #1976d2;
          color: #fff;
          cursor: pointer;
        `
      : css`
          border: 1.5px solid #bdbdbd;
          background: #fff;
          color: #616161;
          cursor: pointer;
        `}

  &:disabled {
    cursor: default;
  }
`;

export const EmptyLabel = styled.span`
  margin-top: 0.25rem;
  display: block;
  color: ${theme.colors.gray};
`;

export const ErrorLabel = styled.span`
  margin-top: 0.25rem;
  display: block;
  color: ${theme.colors.error};
`;

/* ── AddAttachment ─────────────────────────────────────────────────────── */

export const HeaderActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const FallbackContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FallbackErrorText = styled(Text)`
  margin-right: 4px;
`;

export const FallbackEmptyText = styled(Text)`
  margin-right: 8px;
`;

/* ── AttachmentItem ────────────────────────────────────────────────────── */

export const AccordionContainer = styled.div`
  border: 1px solid #e4e6ef;
  border-radius: 6px;
  overflow: hidden;
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: #f9f9f9;
  cursor: ${({ isExpandable }) => (isExpandable ? 'pointer' : 'default')};
  gap: 0.5rem;
  user-select: none;
`;

export const FileIconWrapper = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const FileNameText = styled(Text)`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const FileSizeText = styled(Text)`
  flex-shrink: 0;
  white-space: nowrap;
`;

export const AttachmentNfBadge = styled.span`
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.72rem;
  font-weight: 600;
  flex-shrink: 0;
  white-space: nowrap;
  background: ${({ active }) => (active ? '#e8f5e9' : '#f5f5f5')};
  color: ${({ active }) => (active ? '#2e7d32' : '#757575')};
`;

export const RemoveButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: ${({ sm }) => (sm ? '0.2rem' : '0.25rem')};
  flex-shrink: 0;
  &:disabled {
    cursor: not-allowed;
  }
`;

export const ChevronWrapper = styled.span`
  flex-shrink: 0;
  color: #9e9e9e;
  line-height: 0;
`;

export const AccordionBody = styled.div`
  padding: 0.75rem;
  border-top: 1px solid #e4e6ef;
`;

export const MultiFileList = styled.div`
  margin-bottom: ${({ showDelivery }) => (showDelivery ? '0.75rem' : '0')};
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem 0;
`;

export const FileRowNameText = styled(Text)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemoveAllRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.25rem;
`;

export const RemoveAllButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.25rem;
  color: ${theme.colors.danger};
  font-size: 0.75rem;
  &:disabled {
    cursor: not-allowed;
  }
`;
